import { createSelector } from "reselect";
import { filter } from "lodash";
import { RootState } from "../reducers";

export const selectOrganization = (state: RootState) =>
  state.organizations.organization.data;

export const selectOrganizationIncluded = (state: RootState) =>
  state.organizations.organization.included;

export const selectOrganizationOffices = createSelector(
  selectOrganizationIncluded,
  included => filter(included, related => related.type === "offices"),
);

export const selectOrganizationUsers = createSelector(
  selectOrganizationIncluded,
  included => filter(included, related => related.type === "users"),
);

export const selectSelectedAdmin = (state: RootState) =>
  state.organizations.admin.data;

export const selectOrganizationAdmins = createSelector(
  selectOrganizationUsers,
  users =>
    filter(
      users,
      user =>
        user.attributes.role === "admin" || user.attributes.role === "owner",
    ),
);

export const selectOrganizationDrawer = (state: RootState) =>
  state.organizations.drawer;

export const selectOrganizationTabData = createSelector(
  selectOrganization,
  selectOrganizationOffices,
  selectOrganizationAdmins,
  (organization, offices, admins) => ({
    organizationId: organization.id,
    name: organization.attributes.name,
    primaryContact: {
      name: organization.attributes.primaryContactName,
      email: organization.attributes.primaryContactEmail,
      phone: organization.attributes.primaryContactPhone,
      location: organization.attributes.primaryContactLocation,
    },
    offices: offices.map(office => ({
      officeId: office.id,
      status: office.status,
      ...office.attributes,
    })),
    admins: admins.map(admin => ({
      userId: admin.id,
      ...admin.attributes,
    })),
  }),
);
